/* eslint-disable no-unused-vars */
export enum AddressType {
  PRIMARY = 0,
  SECONDARY = 1,
}
export enum LegalFormType {
  SOLE_TRADER = 'SOLE_TRADER',
  REGISTERED_SOLE_TRADER = 'REGISTERED_SOLE_TRADER',
  FREELANCER = 'FREELANCER',
}
export enum VehicleDefects {
  DEFECTS = 'DEFECTS',
  NO_DEFECTS = 'NO_DEFECTS',
}
export enum LicenseClassType {
  B = 'B',
  TWO = '2',
  THREE = '3',
  OTHER = 'Andere',
}

export enum TruthType {
  TRUE = 'true',
  FALSE = 'false',
}

export enum PickupLocationType {
  CUSTOMERADDRESS = 'CUSTOMERADDRESS',
  OTHERADDRESS = 'OTHERADDRESS',
}

export enum OauthProviders {
  VERIMI = 'Verimi',
  VW = 'Volkswagen ID',
}

// Enum key is <FrontendBrand_AuthorizationProvider>.
// Enum value is defined by Id Broker
export enum OauthProvidersHint {
  VWFS_VERIMI = 'verimivwfs',
  VWFS_VW = 'identitykitaabovwfs',
  VW_VW = 'identitykitaabovw',
}

export enum DealerRole {
  PICKUP = 'PICKUP',
}

export enum TestProcedureType {
  WLTP = 'WLTP',
  NEDC = 'NEDC',
}

export enum EmissionsType {
  CO2 = 'CO2',
  NOX = 'NOX',
}

export enum TransactionStatus {
  CONTRACT_SIGNED = 'CONTRACT_SIGNED',
}

export enum EngineType {
  INTERNAL_COMBUSTION_ENGINE = 'INTERNAL_COMBUSTION_ENGINE',
  EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE = 'EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE',
  NOT_EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE = 'NOT_EXTERNALLY_CHARGEABLE_HYBRID_ELECTRIC_VEHICLE',
  PURE_ELECTRIC_VEHICLE = 'PURE_ELECTRIC_VEHICLE',
}

export enum EnergyManagementType {
  UNESPECIFIED = 'UNESPECIFIED',
  PURE = 'PURE',
  SUSTAINING = 'SUSTAINING',
}

export enum MimeType {
  SVG = 'image/svg+xml',
  PDF = 'application/pdf',
}

export enum BasicPollingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum manufacturers {
  VW = 'Volkswagen',
  VWCV = 'Volkswagen Nutzfahrzeuge',
  SEAT = 'SEAT',
  SKODA = 'Skoda',
  AUDI = 'Audi',
  CUPRA = 'CUPRA',
}

export enum FirstUsage {
  AUDI_MANUFACTURER_COMPANY_CAR = "AudiManufacturerCompanyCar",
  COMPANY_CAR = "CompanyCar",
  DEMONSTRATION_CAR = "DemonstrationCar",
  DRIVING_SCHOOL_CAR = "DrivingSchoolCar",
  EUROMOBIL = "Euromobil",
  EXTERNAL_DEALER_DEMONSTRATION_CAR = "ExternalDealerDemonstrationCar",
  LEASING = "Leasing",
  LEASING_RETURNED_VEHICLE = "LeasingReturnedVehicle",
  MAJOR_CUSTOMER_TEST_CAR = "MajorCustomerTestCar",
  NONE = "None",
  ONE_DAY_OLD_CAR = "OneDayOldCar",
  ONE_YEAR_OLD_CAR = "OneYearOldCar",
  OTHER = "Other",
  PERSON_EMPLOYEE_VW_GROUP_LEASING = "PersonEmployeeVWGroupLeasing",
  PERSON_EMPLOYEE_VW_GROUP_LEASING_RETURNED = "PersonEmployeeVWGroupLeasingReturned",
  PLANT_COMPANY_CAR = "PlantCompanyCar",
  POLICE = "Police",
  PROMOTION_CAR = "PromotionCar",
  REMARKETING_VEHICLE = "RemarketingVehicle",
  RENTAL_CAR = "RentalCar",
  RESTRICTION_VEHICLE = "RestrictionVehicle",
  RETURNED_EMPLOYEE_VEHICLE = "ReturnedEmployeeVehicle",
  SEAT_MANUFACTURER_COMPANY_CAR = "SeatManufacturerCompanyCar",
  SKODA_MANUFACTURER_COMPANY_CAR = "SkodaManufacturerCompanyCar",
  TAXI = "Taxi",
  VW_MANUFACTURER_COMPANY_CAR = "VWManufacturerCompanyCar"
}

export enum ValidTypeEntered {
  LETTERS = "Buchstaben",
  NUMBERS = "Zahlen",
}

export enum CustomerRole {
  PRIVATE = "PRIVATE",
  ORGANIZATION = "ORGANIZATION",
  BUSINESS = "BUSINESS",
  ENTREPRENEUR = "ENTREPRENEUR",
  PARTNERSHIP = "PARTNERSHIP",
  CIVIL_PARTNERSHIP = "CIVIL_PARTNERSHIP"
}
